import { createAction, props } from '@ngrx/store';

import * as models from '../models';

export const load = createAction(
  '[AccountOwnerCollection] Load',
  props<{ name?: string }>()
);
export const loadSuccess = createAction(
  '[AccountOwnerCollection] Load Success',
  props<{ payload: Array<models.AccountOwner> }>()
);
export const loadFail = createAction('[AccountOwnerCollection] Load Fail');
